<ngx-spinner
  name="spinner"
  [fullScreen]="true"
  type="timer"
  size="medium"
  bdColor="#000000"
  [disableAnimation]="true"
  template="<img src='assets/img/bbj-pmis-load-icon.svg'/> "
  >
</ngx-spinner>

<div class="content">
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</div>
